import { Type } from './type';
export var DomRenderer_$type = /*@__PURE__*/ new Type(null, "DomRenderer");
export var DomWrapper_$type = /*@__PURE__*/ new Type(null, "DomWrapper");
export var DomPortal_$type = /*@__PURE__*/ new Type(null, "DomPortal");
var DomWrapperPosition_$type = /*@__PURE__*/ new Type(null, "DomWrapperPosition");
var NormalizedEvent_$type = /*@__PURE__*/ new Type(null, "NormalizedEvent");
//# sourceMappingURL=dom.js.map
